import RelatedSectionImplementation from '../implementation/sections/RelatedSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiRelatedSectionDTO,
  RelatedSectionDTO,
} from '@lib/strapi/dtos/components/sections/relatedSection.dto';

const RelatedSection = (props: ComponentProps<RelatedSectionDTO>) => {
  return <RelatedSectionImplementation {...props}></RelatedSectionImplementation>;
};

export default RelatedSection;
